import {ProductType} from '@web/core/constants'
import makeSlice from '@web/slices/orderSheetProducts/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (_, {payload}) => {
            const {products} = payload
            return products.map((product) => {
                return {
                    id: product.orderSheetProductId,
                    name: product.productName,
                    url: product.productUrl,
                    imageUrl: product.productImageUrl,
                    type: ProductType.NORMAL,
                    unitPrice: product.salePrice,
                    naverBenefit: product.naverBenefit,
                    customOrderDetailType: null,
                    preOrder: null,
                    merchantInfo: {
                        merchantProductId: product.merchantProductId,
                        merchantNo: product.merchantNo,
                        merchantChannelName: null,
                        merchantChannelServiceType: null,
                    },
                    deliveryInfo: {
                        deliveryGroupKey: product.deliveryGroupKey,
                        deliveryAttributeType: null,
                        // C1 은 해외 배송 라벨을 노출하지 않습니다
                        overseasDelivery: false,
                        branch: null,
                        todayDispatch: null,
                        hopeDelivery: null,
                        deliveryPrediction: null,
                    },
                    items: product.items.map((item) => {
                        return {
                            orderSheetItemId: item.orderSheetItemId,
                            productClassType: item.productClassType,
                            itemNo: item.itemNo,
                            price: item.price,
                            quantity: item.quantity,
                            orderAmount: item.orderAmount,
                            optionContents: item.optionContents,
                            branchId: null,
                            branchBenefitType: null,
                            branchBenefitValue: null,
                            branchBenefitApplyValue: null,
                            elements: item.elements,
                        }
                    }),
                    gift: product.gift,
                    cupDeposit: product.cupDeposit,
                    ecouponBarcodeConnect: null,
                    arrivalGuaranteeDateTime: null,
                    arrivalGuaranteeCheckedDateTime: null,
                    rmid: null,
                    installationProduct: null,
                    quantity: null,
                    orderAmount: null,
                    outboundLocationId: null,
                }
            })
        })
    },
})

export default slice.reducer
